import { ALB_LOGIN_CHECK_ENDPOINT_URL } from '@utilities/constants';

export const albLoginCheckEndpoint = async () => await fetch(ALB_LOGIN_CHECK_ENDPOINT_URL);
